import { useCallback, useState } from "react";
import { DisabledWithTooltip } from "@design-system/DisabledWithTooltip/DisabledWithTooltip";
import { Input } from "@design-system/Input/Input";

interface Props {
    value: string;
    onChange: (value: string) => void;
    readOnly?: boolean;
    disabledReason?: string;
    className?: string;
}

export const ImporterBankInput: React.FC<Props> = ({
    value,
    onChange,
    readOnly,
    disabledReason,
    className,
}) => {
    const isReadOnly = readOnly || !!disabledReason;
    const [localValue, setLocalValue] = useState(value);
    const [prevValue, setPrevValue] = useState(value);
    if (value !== prevValue) {
        setPrevValue(value);
        setLocalValue(value);
    }

    const handleBlur = useCallback(() => {
        if (localValue !== value) {
            onChange(localValue);
        }
    }, [localValue, value, onChange]);

    return (
        <DisabledWithTooltip reason={disabledReason}>
            <Input
                size="lg"
                className={className}
                value={localValue}
                onChange={(event) => setLocalValue(event.target.value)}
                onBlur={handleBlur}
                onKeyDown={(event) => {
                    if (event.key === "Enter") {
                        handleBlur();
                        event.currentTarget.blur();
                    }
                }}
                readOnly={isReadOnly}
            />
        </DisabledWithTooltip>
    );
};
